import { TableBody, TableCell, TableHead, TableRow, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import Refresh from "@material-ui/icons/Refresh";
import ApolloClient from "apollo-client";
import React from "react";
import { PlanosConciliadoresTaxasDao } from "../../../../graphql/components";
import voca from "voca";
import TabelaRolavel from "../../../../componentes/Tables/TabelaRolavel";
import LinhaSemRegistros from "../../../../componentes/Tables/LinhaSemRegistros";

interface Props {
  classes?: any;
  data: Array<PlanosConciliadoresTaxasDao>;
  atualizaTaxas: (client: ApolloClient<any>, codigo: number | undefined) => void;
  subTaxas: (client: ApolloClient<any>, codigo: number | undefined) => void;
  client: ApolloClient<any>;
}

const TabelaTaxasPorParcela = ({ classes, data, atualizaTaxas, subTaxas, client }: Props) => {
  return (
    <TabelaRolavel>
      <TableHead>
        <TableRow>
          <TableCell align="right">Parcela Inicial</TableCell>
          <TableCell align="right">Parcela Final</TableCell>
          <TableCell align="right">Registros De</TableCell>
          <TableCell align="right">Taxas em %</TableCell>
          <TableCell align="center">Ações</TableCell>
        </TableRow>
      </TableHead>
      {data.length === 0 ? (
        <LinhaSemRegistros colunas={5} titulo="Nenhuma taxa cadastrada" apoio="Preencha os campos acima para adicionar a primeira faixa." />
      ) : (
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.codplanosconciliadorestaxas}>
              <TableCell align="right">{row.de}</TableCell>
              <TableCell align="right">{row.ate}</TableCell>
              <TableCell align="right">{voca.replaceAll(voca.sprintf("%.2f", row.taxa), ".", ",")}</TableCell>
              <TableCell align="right">{row.tipotaxa === "V" ? "R$" : "%"}</TableCell>
              <TableCell align="center">
                <Tooltip title="Atualizar" placement="top" onClick={() => atualizaTaxas(client, row.codplanosconciliadorestaxas)}>
                  <Refresh style={{ color: "gray", fontSize: 15, cursor: "pointer", marginRight: 15 }} />
                </Tooltip>

                <Tooltip title="Deletar" placement="top" onClick={() => subTaxas(client, row.codplanosconciliadorestaxas)}>
                  <DeleteIcon style={{ color: "gray", fontSize: 15, cursor: "pointer" }} />
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      )}
    </TabelaRolavel>
  );
};

export default TabelaTaxasPorParcela;
